import bcMiniGameApi from "apis/bc-minigame-api";
import { RootState, useAppSelector } from "cache/store";
import { ParamBetMiniBC, PayloadBodyTopicBC, StatsCountMiniBC } from "models/mini-bc-model";
import { ChatItemTXCB, PayloadBodyUserQueueTXCB } from "models/txcb-model";
import { useEffect, useRef, useState } from "react";
import bcFunction, { chatSuggestBC } from "./bc-function";
import bcSocket from "socket/baucua-socket";
import './baucua.scss';
import BoardBc from "./board-bc";
import StatsMiniBC from "./stats-mini-bc";
import BoxChatMinigame from "components/BoxChatMinigame/box-chat-minigame";
import Modal from "components/modal/Modal";
import HDBCMiniGame from "./hd/hd";
import LSCBCMiniGame from "./lsc/lsc";
import MiniRank from "../bxh/bxh";

interface Props {
    onClose: () => void;
    onChangeMsg: (inputData: string) => void;
}
export default function BaucuaMiniGame(props: Props) {
    const { onClose, onChangeMsg } = props;

    const maintainGame = useRef(false);
    const pageDom = useRef<HTMLDivElement>(null);
    const hisPhienData = useRef<{ id: number; result: number[] }[]>([]);
    const { stompBC } = useAppSelector((state: RootState) => state.socket);
    const { userInfo, tokenBC } = useAppSelector((state: RootState) => state.auth);

    const [topicData, setTopicData] = useState({} as PayloadBodyTopicBC);
    const [userQueueData, setUserQueueData] = useState({} as PayloadBodyUserQueueTXCB);

    const [showRank, setShowRank] = useState(false);
    const [rankData, setRankData] = useState<any[]>([]);

    const [showHistoryMyBet, setShowHistoryMyBet] = useState(false);

    const [showHelp, setShowHelp] = useState(false);

    const [showChat, setShowChat] = useState(false);
    const [chatList, setChatList] = useState<ChatItemTXCB[]>([]);
    const [isMuted, setIsMuted] = useState(false);

    const [statsData, setStatsData] = useState<StatsCountMiniBC>({
        bau: 0,
        cua: 0,
        tom: 0,
        ca: 0,
        ga: 0,
        nai: 0,
    });
    const [hisIssueList, setHisIssueList] = useState<number[][]>([]);

    useEffect(() => {
        if (stompBC) {
            stompBC.subscribe('/topic/bc', (data: { body: string }) => {
                const body: PayloadBodyTopicBC = JSON.parse(data.body);
                if (body.cmd === 12 && body.rs) {
                    maintainGame.current = true;
                }

                //chat response
                if (body.cmd === 11) {
                    setChatList((list) => {
                        if (list.length > 0) {
                            return [...list, body.data[body.data.length - 1]];
                        } else {
                            return [...list, ...body.data];
                        }
                    });
                }
                setTopicData(body);
            });

            stompBC.subscribe('/user/queue/bc', (data: any) => {
                const body: PayloadBodyUserQueueTXCB = JSON.parse(data.body);
                setUserQueueData(body);

                //chat
                if (body.cmd === 11) {
                    const lastMsg = body.data[body.data.length - 1];
                    setChatList((list) => [...list, lastMsg as any]);
                }
            });
        }
    }, [stompBC]);

    const handleGetMsg = (msg: any) => {
        onChangeMsg(msg);
    };

    useEffect(() => {
        const getStatsRecord = async () => {
            try {
                const { data } = await bcMiniGameApi.getStatistic();
                if (Array.isArray(data)) {
                    const statsData = bcFunction.calcstatsTotal(
                        data.map((item) => ({ ...item, result: JSON.parse(item.result) })),
                        {} as StatsCountMiniBC
                    );
                    if (data.length > 0) {
                        let hisIssueData: number[][] = [];
                        data.forEach((issue) => {
                            const result: number[] = JSON.parse(issue.result);
                            hisIssueData = [result, ...hisIssueData];
                        });
                        if (hisIssueData.length > 10) {
                            hisIssueData = hisIssueData.slice(-10);
                        }
                        setHisIssueList(hisIssueData);
                    }

                    setStatsData(statsData);
                }
            } catch (error) {
                console.log(error);
            }
        };
        getStatsRecord();
    }, []);

    const submitBet = (topic: string, payload: ParamBetMiniBC) => {
        if (stompBC && stompBC.connected) {
            payload = { ...payload, userId: userInfo.id, loginname: userInfo.loginname, userType: userInfo.usertype };
            bcSocket.sendMessage(topic, payload);
        }
    };

    const getRank = async () => {
        setShowRank(true);
        const params = {
            type: 2,
            access_token: tokenBC || '',
        };
        try {
            const { data } = await bcMiniGameApi.getRank(params);
            const topTen = (data as any)
                .filter((item: any) => item.amount && item.amount > 0)
                .sort((a: any, b: any) => b['amount'] - a['amount'])
                .slice(0, 10);
            setRankData(topTen);
        } catch (error) {
            console.log(error);
        }
    };

    const sendChat = (msg: string, cb: () => void) => {
        if (Number(userInfo.balance) < 20000) {
            handleGetMsg('Số dư của bạn phải trên 20,000 để có thể chat!');
            return;
        }
        const payload = {
            u: userInfo.loginname,
            m: msg,
        };
        bcSocket.sendMessage('/topic/bc/chat', payload);
        cb();
    };

    const toggleSound = () => {
        setIsMuted(!isMuted);
    };

    return (
    <div className="bc-page">
        <div className="content-mini-bc">
            <div className="bc-mini-page" ref={pageDom}>
                <div className="wrap-game">
                    <div className="board-game">
                        <div className="btn-header-list">
                            <div className="btn-group">
                                <button className="btn-reset" onClick={getRank}>
                                    <img src={require(`assets/images/txcb/btn-rank.png`)} alt=""/>
                                </button>

                                <button className="btn-reset" onClick={() => setShowHistoryMyBet(true)}>
                                    <img src={require(`assets/images/txcb/btn-his-bet.png`)} alt=""/>
                                </button>
                                <button className="btn-reset" onClick={toggleSound}>
                                    {isMuted ? (
                                        <img src={require(`assets/images/icons/sound-off.png`)} alt=""/>
                                    ) : (
                                        <img src={require(`assets/images/icons/sound-on.png`)} alt=""/>
                                    )}
                                </button>
                            </div>
                            <div className="btn-group">
                                <button className="btn-reset" onClick={() => setShowHelp(true)}>
                                    <img src={require(`assets/images/txcb/btn-help.png`)} alt=""/>
                                </button>
                                <button className="btn-reset" onClick={() => setShowChat(!showChat)}>
                                    {!showChat ? (
                                        <img src={require(`assets/images/icons/chat-off.png`)} alt=""/>
                                    ) : (
                                        <img src={require(`assets/images/icons/chat-on.png`)} alt=""/>
                                    )}
                                </button>
                                <button className="btn-reset" onClick={onClose}>
                                    <img src={require(`assets/images/txcb/btn-close.png`)} alt=""/>
                                </button>
                            </div>
                        </div>
                        <BoardBc
                            ref={pageDom}
                            balance={userInfo.balance}
                            bodyTopic={topicData}
                            userQueue={userQueueData}
                            onBet={submitBet}
                            lspData={hisPhienData.current}
                            onUpdatePhien={(value) => (hisPhienData.current = value)}
                            isMuted={isMuted}
                            onChangeMsg={handleGetMsg}
                        />

                    </div>
                </div>
                <div className={`chat-box ${showChat ? 'show' : ''}`}>
                    <StatsMiniBC statsData={statsData} hisIssueList={hisIssueList} />
                    <BoxChatMinigame
                        chatList={showChat ? chatList : []}
                        chatSuggest={chatSuggestBC}
                        onSend={sendChat}
                        onClose={() => setShowChat(false)}
                    />
                </div>
            </div>
            
        </div>

        <Modal isShow={showHelp} onClose={() => setShowHelp(false)} width="920px">
            <HDBCMiniGame onClose={() => setShowHelp(false)} />
        </Modal>

        <Modal isShow={showHistoryMyBet} onClose={() => setShowHistoryMyBet(false)} width="920px">
            <LSCBCMiniGame onClose={() => setShowHistoryMyBet(false)} />
        </Modal>

        <Modal isShow={showRank} onClose={() => setShowRank(false)} width="920px">
            <MiniRank rankList={rankData} onClose={() => setShowRank(false)} />
        </Modal>
    </div>
    );
}
